import { render, staticRenderFns } from "./SelectArtistType.vue?vue&type=template&id=dc24af8a&scoped=true&"
import script from "./SelectArtistType.vue?vue&type=script&lang=js&"
export * from "./SelectArtistType.vue?vue&type=script&lang=js&"
import style0 from "./SelectArtistType.vue?vue&type=style&index=0&id=dc24af8a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc24af8a",
  null
  
)

export default component.exports